module.exports = __webpack_public_path__ + "img/twitter.54ff2e63.svg";